// extracted by mini-css-extract-plugin
module.exports = {"name":"style__name__2-nCs"};